<div class="dialog-header">
    <div class="title-container">
        <h1 mat-dialog-title>Über...</h1>
    </div>
    <div class="logo"></div>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
    <div class="version-info">
        <div>
            <span>Version</span>
            @if (appVersion) {
            <span class="value">:&nbsp;{{ appVersion }}</span>
            } @else {
            <span class="value">:&nbsp;---</span>
            }
        </div>
        <div>
            <span>Erstellt am</span>
            @if (appBuildDate) {
            <span class="value">:&nbsp;{{ appBuildDate | date: "medium" }}</span>
            } @else {
            <span class="value">:&nbsp;---</span>
            }
        </div>
        @if (angularVersion) {
        <div>
            <span>Angular-Version</span>
            <span class="value">:&nbsp;{{ angularVersion }}</span>
        </div>
        }
        @if (pixlEditorVersion) {
        <div>
            <span>PIXL-Version</span>
            <span class="value">:&nbsp;{{ pixlEditorVersion }}</span>
        </div>
        }
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>
<div
    mat-dialog-actions
    align="end"
>
    <button
        mat-raised-button
        color="primary"
        (click)="onClose()"
    >Schließen</button>
</div>